import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoAccept = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	fill: "none",
	viewBox: "0 0 36 36",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M24.455 9.814a1.25 1.25 0 1 1 2.09 1.371l-10.5 16a1.25 1.25 0 0 1-2.015.103l-6.5-8a1.25 1.25 0 1 1 1.94-1.576l5.422 6.674z"
	})
});
export default SvgIcoAccept;
